import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Typography } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import { MISSING_REQUIRED_DATA_MODAL } from "../constants";
import type { MissingRequiredDataModalProps } from "../types";
import useMissingRequiredDataModalStyles from "./MissingRequiredDataModal.styles";

const MissingRequiredDataModal = ({ isOpen, onClose, onExited }: MissingRequiredDataModalProps) => {
  const classes = useMissingRequiredDataModalStyles();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      TransitionProps={{ onExited }}
      fullWidth
      maxWidth={false}
      classes={{ paper: classes.paper }}
      aria-labelledby="missing-required-data-title"
      aria-describedby="missing-required-data-description missing-required-data-detail"
    >
      <DialogContent className={classes.content}>
        <ErrorOutlineIcon className={classes.errorIcon} />
        <Typography component="h2" id="missing-required-data-title" className={classes.title}>
          {MISSING_REQUIRED_DATA_MODAL.title}
        </Typography>
        <Typography id="missing-required-data-description" className={classes.description}>
          {MISSING_REQUIRED_DATA_MODAL.description}
        </Typography>
        <Divider className={classes.divider} />
        <Box className={classes.detail}>
          <Box className={classes.clipboard}>
            <AssignmentOutlinedIcon />
          </Box>
          <Typography id="missing-required-data-detail" className={classes.detailText}>
            {MISSING_REQUIRED_DATA_MODAL.detail}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button autoFocus variant="contained" className={classes.acknowledgeButton} onClick={onClose}>
          {MISSING_REQUIRED_DATA_MODAL.acknowledgeLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MissingRequiredDataModal;
